import React from 'react'
import { Message } from 'semantic-ui-react'

import useAxios from 'hooks/useAxios'
import useWorkspace from 'hooks/useWorkspace'

export const TrialWarningMessage = () => {
  const workspaceToken = useWorkspace()
  const userInfo = useAxios({
    url: 'account/users/me/v2/',
  })

  if (userInfo?.data?.subscription?.status !== 'trialing') {
    return null
  }
  return (
    <Message info>
      <p>
        Trial accounts are limited to send 50 emails per day.{' '}
        <a href={`${workspaceToken}/settings/billing/`}>Upgrade your account.</a>
      </p>
    </Message>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/TrialWarningMessage/index.js